import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = { class: "flex flex-row-reverse" }

import { computed, onMounted, reactive, watch } from "vue";
import Modal from "@/components/common/Modal.vue";
import { RoleGetters } from "@/store/modules/role/getters";
import { useStore } from "vuex";
import VueTableLite from "vue3-table-lite/ts";
import TablePagination from "@/components/common/pagination/TablePagination.vue";
import Button from "@/components/common/Button.vue";
import { ReportFileActions } from "@/store/modules/reportFile/actions";
import { ReportFileGetters } from "@/store/modules/reportFile/getters";
import { ReportTemplateActions } from "@/store/modules/reportTemplate/actions";
import ReportDataService from "@/services/report/ReportDataService";
import { DownloadIcon } from "@heroicons/vue/outline";


export default /*#__PURE__*/_defineComponent({
  props: {
  show: {
    type: Boolean,
    required: true,
  },
},
  setup(__props) {

const props = __props



const store = useStore();

const dataProvider = computed(() => {
  return store.getters[ReportFileGetters.GET_DATA_PROVIDER];
});
const roles = computed(() => {
  return dataProvider.value.items;
});
const pager = computed(() => {
  return dataProvider.value.pager;
});

const table = reactive({
  isLoading: false,
  columns: [
    {
      label: "Название",
      field: "name",
      sortable: false,
    },
    {
      label: "",
      field: "action",
      sortable: false,
    },
  ],
  rows: roles,
  totalRecordCount: 0,
});

const downloadReport = async (name: string, fileGuid: string) => {
  await ReportDataService.downloadReport(fileGuid)
    .then((response) => {
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = name + ".xlsx";
      link.click();
      URL.revokeObjectURL(link.href);
    })
    .catch(console.error);
};

watch(
  () => props.show,
  async () => {
    if (!props.show) {
      return;
    }

    await store.dispatch(ReportFileActions.FETCH_DATA_PROVIDER, {
      page: 1,
    });
  }
);

onMounted(async () => {
  await store.dispatch(ReportFileActions.FETCH_DATA_PROVIDER, {
    page: 1,
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    title: "Созданные отчеты",
    show: __props.show,
    onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close', false)))
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(VueTableLite), {
        "data-pagination-scroll-anchor": "",
        "is-slot-mode": true,
        "is-loading": _unref(table).isLoading,
        columns: _unref(table).columns,
        rows: _unref(table).rows,
        total: _unref(table).totalRecordCount,
        sortable: false,
        "is-hide-paging": true,
        messages: { noDataAvailable: 'Ничего не найдено' }
      }, {
        action: _withCtx((data) => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(Button, {
              onClick: ($event: any) => (downloadReport(data.value.name, data.value.guid))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(DownloadIcon), { style: {"width":"22px"} })
              ]),
              _: 2
            }, 1032, ["onClick"])
          ])
        ]),
        _: 1
      }, 8, ["is-loading", "columns", "rows", "total"]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(TablePagination, {
          current: _unref(pager).currentPage,
          "onUpdate:current": _cache[0] || (_cache[0] = ($event: any) => ((_unref(pager).currentPage) = $event)),
          "total-pages": _unref(pager).totalPages,
          "onUpdate:total-pages": _cache[1] || (_cache[1] = ($event: any) => ((_unref(pager).totalPages) = $event)),
          "start-page": _unref(pager).startPage,
          "end-page": _unref(pager).endPage,
          onPageChanged: _ctx.getPage
        }, null, 8, ["current", "total-pages", "start-page", "end-page", "onPageChanged"])
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})